<script setup>
import { useI18n } from "vue-i18n";
import { FormInput, FormLabel } from "@Components/Form";

defineProps(["modelValue"]);
defineEmits(["update:modelValue"]);

const { t: __ } = useI18n();
</script>

<template>
    <div>
        <div class="text-sm font-medium leading-6 text-gray-900 dark:text-white">{{ __("Thème") }}</div>
        <div class="grid grid-cols-3 gap-6 mt-2">
            <div>
                <div class="text-sm font-medium leading-6 text-gray-900 dark:text-white">{{ __("Conteneur") }}</div>
                <div class="mt-2 space-y-6">
                    <FormInput v-model="modelValue.theme.wrapper.padding" :label="__('Padding')" :placeholder="__('Exemple: 1rem')" />
                    <div>
                        <FormLabel for="linking-automatic-template-theme-wrapper-color">{{ __("Background color") }}</FormLabel>
                        <div class="flex items-center mt-2 space-x-1.5">
                            <input
                                type="color"
                                v-model="modelValue.theme.wrapper.backgroundColor"
                                class="w-9 h-9 flex-none border-none"
                                style="background: none" />
                            <div class="flex-1">
                                <FormInput
                                    id="linking-automatic-template-theme-wrapper-color"
                                    v-model="modelValue.theme.wrapper.backgroundColor"
                                    :placeholder="__('Exemple: #000000')" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div class="text-sm font-medium leading-6 text-gray-900 dark:text-white">{{ __("Titre") }}</div>
                <div class="mt-2 space-y-6">
                    <div>
                        <FormLabel for="linking-automatic-template-theme-title-color">{{ __("Color") }}</FormLabel>
                        <div class="flex items-center mt-2 space-x-1.5">
                            <input type="color" v-model="modelValue.theme.title.color" class="w-9 h-9 flex-none border-none" style="background: none" />
                            <div class="flex-1">
                                <FormInput
                                    id="linking-automatic-template-theme-title-color"
                                    v-model="modelValue.theme.title.color"
                                    :placeholder="__('Exemple: #000000')" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div class="text-sm font-medium leading-6 text-gray-900 dark:text-white">{{ __("Extrait") }}</div>
                <div class="mt-2 space-y-6">
                    <div>
                        <FormLabel for="linking-automatic-template-theme-excerpt-color">{{ __("Color") }}</FormLabel>
                        <div class="flex items-center mt-2 space-x-1.5">
                            <input type="color" v-model="modelValue.theme.excerpt.color" class="w-9 h-9 flex-none border-none" style="background: none" />
                            <div class="flex-1">
                                <FormInput
                                    id="linking-automatic-template-theme-excerpt-color"
                                    v-model="modelValue.theme.excerpt.color"
                                    :placeholder="__('Exemple: #000000')" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
